import { useId, type InputHTMLAttributes } from 'react'
import './Field.css'

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  hint?: string
  error?: string | null
}

/** A labelled text input for forms: the label sits above, the hint or error below. */
export function Field({ label, hint, error, id, className = '', ...rest }: FieldProps) {
  const auto = useId()
  const inputId = id ?? auto
  const hintId = `${inputId}-hint`
  return (
    <div className={`field ${error ? 'field--error' : ''} ${className}`}>
      <label className="field__label" htmlFor={inputId}>
        {label}
      </label>
      <input id={inputId} className="field__input" aria-describedby={hint || error ? hintId : undefined} aria-invalid={error ? true : undefined} {...rest} />
      {(error || hint) && (
        <div id={hintId} className="field__hint">
          {error || hint}
        </div>
      )}
    </div>
  )
}
